module.exports = __webpack_public_path__ + "img/LogoVEQCapital_Gris.ce3565b6.png";